export const MODE = {
	RENDER: 'RENDER' as const,
	HYDRATE: 'HYDRATE' as const,
};
